import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=084f7c43&"
import script from "./Breadcrumbs.js?vue&type=script&lang=js&"
export * from "./Breadcrumbs.js?vue&type=script&lang=js&"
import style0 from "./Breadcrumbs.scss?vue&type=style&index=0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports